import React from "react";
import {
  Clock,
  FileText,
  Calendar,
  DollarSign,
  Activity,
  Package,
  BarChart2,
  Shield
} from "react-feather";
import benefitimg from "../../assets/images/landingpage/dash-benefit.png"

const HMSBenefits = () => {

  const features = [
    {
      icon: <Clock size={40} className="lanp-secondary-text" />,
      title: "Fast Registration",
      desc: "Quick patient onboarding with minimal data entry and zero delays."
    },
    {
      icon: <FileText size={40} className="lanp-secondary-text" />,
      title: "Digital Records",
      desc: "Secure and easily accessible electronic health records system."
    },
    {
      icon: <Calendar size={40} className="lanp-secondary-text" />,
      title: "Appointment Management",
      desc: "Efficient scheduling system to manage patient appointments."
    },
    {
      icon: <DollarSign size={40} className="lanp-secondary-text" />,
      title: "Automated Billing",
      desc: "Generate accurate bills instantly with automated calculations."
    },
    {
      icon: <Activity size={40} className="lanp-secondary-text" />,
      title: "Pharmacy Management",
      desc: "Track prescriptions, medicines, and pharmacy operations easily."
    },
    {
      icon: <Package size={40} className="lanp-secondary-text" />,
      title: "Inventory Control",
      desc: "Monitor hospital inventory and avoid stock shortages."
    },
    {
      icon: <BarChart2 size={40} className="lanp-secondary-text" />,
      title: "Real-Time Reports",
      desc: "Get analytics and insights to improve decision making."
    },
    {
      icon: <Shield size={40} className="lanp-secondary-text" />,
      title: "Data Security",
      desc: "Ensure complete protection of sensitive patient information."
    }
  ];

  return (
    <section className="py-5 bg-white">
      <div className="container">

        {/* Heading */}
        <div className="text-center mb-5" data-aos="zoom-in">
          <h2 className="fw-bold  fs-1">
            Key <span className="lanp-primary-text">Benefits</span> of Hospital Management Software 
          </h2>
          <p className="text-muted">
            HMS by AZSM helps hospitals manage operations efficiently,
            improve patient care, and automate workflows with smart technology.
          </p>
        </div>

        {/* Top Section */}
        <div className="row align-items-center mb-5" id="azsmproducts">
          
          <div className="col-lg-6 mb-4 mb-lg-0" data-aos="zoom-in">
            <img
              src={benefitimg}
              alt="Hospital Management System"
              className="img-fluid w-100"
            />
          </div>

          <div className="col-lg-6" data-aos="zoom-in">
            <h4 className="fw-bold mb-3">
              Smart Hospital Management System
            </h4>
            <p className="text-muted">
              AZSM HMS is an advanced software solution designed to manage
              hospital operations including patient data, billing, appointments,
              pharmacy, and reporting from one centralized dashboard.
            </p>

            <ul className="list-group list-group-flush">
              <li className="list-group-item">✔ Easy Patient Management</li>
              <li className="list-group-item">✔ Automated Billing System</li>
              <li className="list-group-item">✔ Real-Time Analytics</li>
              <li className="list-group-item">✔ Cloud-Based Secure Access</li>
            </ul>
          </div>

        </div>

        {/* Features Grid */}
        <div className="row g-4 text-center">

          {features.map((item, index) => (
            <div
              className="col-md-3 col-6"
              key={index}
              data-aos="zoom-in"
            >
              <div className="card h-100 shadow-sm border-danger border-4 border-bottom bg-light">
                <div className="card-body">
                  <div className="mb-2">{item.icon}</div>
                  <h6 className="fw-bold mt-2 text-dark">{item.title}</h6>
                  <p className="small text-muted">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}

        </div>

      </div>
    </section>
  );
};

export default HMSBenefits;